module.exports = __webpack_public_path__ + "static/media/chargeable-car.050fbe24.png";